// extracted by mini-css-extract-plugin
export default {"logoImage":"FondoviDetaljno_logoImage__bF+dM"};